






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import { dpt, grp } from '@/unite/role';
import { Loading } from 'element-ui';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class RunningwaterDetails extends Vue {
  mounted() {
    this.getDpt();
    this.getGrp();
  }
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  modifyForm: any;
  isDpt: boolean = dpt();
  isGrp: boolean = grp();
  rules: any[] = [];
  dptList: object[] = [];
  grpList: object[] = [];
  pageData: any = {
    url: '/back/v1/sim/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      number: '',
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'number', // 字段
        tip: '手机号码',
        placeholder: '请输入查询的手机号码'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '注册sim',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出sim',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: true,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID',
        //   width: 80
        // },
        {
          prop: 'number',
          label: '手机号码',
          width: 125
        },
        {
          prop: 'Online',
          _prop: 'online',
          label: '是否在线',
          type: 'tag',
          color: 'online',
          status: {
            true: '在线',
            false: '不在线'
          }
        },
        {
          prop: 'dpt_name',
          label: '部门'
        },
        {
          prop: 'grp_name',
          label: '分组'
        },
        {
          prop: 'mode',
          // _prop: 'mode',
          label: '模式'
          // status: {
          //   1: 'WebSocket',
          //   2: 'HTTP',
          //   3: 'RPC'
          // }
        },
        {
          prop: 'modify_user',
          label: '上次修改人'
        },
        {
          prop: 'bind_sub',
          label: '订阅者关系'
        },
        {
          prop: 'modify_at',
          label: '上次修改时间',
          type: 'time'
        }
      ],
      expand: [
        {
          value: 'vm_device',
          label: 'vm_device'
        },
        {
          value: 'cat_device',
          label: 'cat_device'
        },
        {
          value: 'wxy_device',
          label: 'wxy_device'
        }
      ],
      optionWidth: 120,
      option: [
        {
          name: '删除',
          methods: 'delete',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '登录',
          methods: 'in',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '登出',
          methods: 'out',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  dialogAddData: any = {
    modifyForm: {
      url: '/back/v1/sim/wxy/register',
      width: '35%',
      form: {
        password: '',
        number : '86',
        dpt_id: '',
        grp_id: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'number',
          name: '手机号码'
        },
        {
          type: 'input',
          model: 'password',
          name: '密码'
        }
      ],
      select: {}
    },
    rules: {
      number: [
        {
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }
      ]
    }
  };
  private handleClick(methods: string, row: any) {
    if (methods === 'delete') {
      this.publicApi(
        `/back/v1/sim/delete?id=${row.id}`,
        `是否确认删除${row.number}`,
        {}
      );
    } else if (methods === 'in') {
      
      this.publicApi(
        `/back/v1/sim/wxy/login?number=${row.number}`,
        `是否确认登录${row.number}`,
        {});
      
    }
    if (methods === 'out') {
      this.publicApi(
        `/back/v1/sim/wxy/logout?number=${row.number}`,
        `是否确认登出${row.number}`,
        {}
      );
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.optionTitle = '注册sim';
      this.visible = true;
      this.dialogAddData.modifyForm.form.password = localStorage.getItem("sim_password")
      this.modifyForm = this.dialogAddData.modifyForm;
      this.rules = this.dialogAddData.rules;
    }
  }
  //保存成功回调
  callback(form: any){
      localStorage.setItem("sim_password", form.password)
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
  private getDpt() {
    if (this.isDpt) {
      get('/back/v1/dpt/list?page_index=1&page_num=10000', {}).then(d => {
        // @ts-ignore
        d.Content.list.forEach(item => {
          this.dptList = [
            ...this.dptList,
            { label: item.name, value: item.id }
          ];
        });
        this.dialogAddData.modifyForm.data.push({
          type: 'select', // text框
          model: 'dpt_id', // 字段
          name: '部门'
        });
        this.dialogAddData.modifyForm.select.dpt_id = this.dptList;
      });
    }
  }
  private getGrp() {
    if (this.isGrp) {
      get('/back/v1/cg/list?page_index=1&page_num=10000', {}).then(d => {
        // @ts-ignore
        d.Content.list.forEach(item => {
          this.grpList = [
            ...this.grpList,
            { label: item.name, value: item.id }
          ];
        });
        this.dialogAddData.modifyForm.data.push({
          type: 'select', // text框
          model: 'grp_id', // 字段
          name: '分组'
        });
        this.dialogAddData.modifyForm.select.grp_id = this.grpList;
      });
    }
  }
  // 公共方法
  publicApi(url: string, msg: string, Infodata: any) {
    this.$confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let loadingInstance = Loading.service({fullscreen: true});
        get(url, Infodata)
          .then(d => {
            // @ts-ignore
            this.$refs.table.getData();
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            loadingInstance.close();
          })
          .catch(e => {
            loadingInstance.close();
            // @ts-ignore
            this.$refs.table.getData();
          });
      })
      .catch(() => {
        // @ts-ignore
        this.$refs.table.getData();
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
  }
}
